module.exports = __webpack_public_path__ + "static/img/3s-info-1.f580dae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/3s-info-1.png
// module id = u+ZD
// module chunks = 0